import React, { useCallback } from 'react';
import RoundedModal from '@components/roundedModal/roundedModal';
import useTranslation from '@hooks/useTranslation';
import styles from './UpgradeCtaModal.module.css';

type Props = {
  /** Whether the modal is visible */
  visible: boolean;
  /** Called when user clicks Cancel or closes the modal */
  onCancel: () => void;
  /** Called when user clicks Upgrade Now */
  onUpgrade: () => void;
};

/**
 * Small CTA modal shown when the user has reached the feature limit (e.g., cannot install more services).
 * Uses the shared rounded modal component and localized strings.
 * @param props.visible Controls modal visibility
 * @param props.onCancel Dismiss handler
 * @param props.onUpgrade Upgrade CTA handler
 * @returns React.JSX.Element
 */
const UpgradeCtaModal = (props: Props): React.JSX.Element => {
  const t = useTranslation('Checkout.UpgradeCta');

  const handleCancel = useCallback(() => {
    props.onCancel();
  }, [props]);

  const handleUpgrade = useCallback(() => {
    props.onUpgrade();
  }, [props]);

  return (
    <RoundedModal
      title={t('Title')}
      visible={props.visible}
      onCancel={handleCancel}
      onOk={handleUpgrade}
      cancelBtnLabel={t.withBaseKey('CommonWords')('Cancel')}
      okBtnLabel={t('UpgradeNow')}
      width={520}
      centered
      noMask={false}
      wrapClassName={styles.Modal}
    >
      <div className={styles.Content}>
        <div>{t('Description')}</div>
      </div>
    </RoundedModal>
  );
};

export default UpgradeCtaModal;


